export const getNewUserRoleDescription = {
  Installer:
    "Installers can install hardware for your organisation but will not be able to see any user data",
  Staff:
    "Staff members can only see the service users assigned to them. Staff can also create new users, complete installations, and assign their service users to their colleagues.",
  Manager:
    "Managers can see all the service users in their organisation. Managers can complete installations, create new service users and staff and assign or remove service users from colleagues.",
};
